import { FilterOption } from 'src/types/filterOption';
import { CompositeFilterDescriptor, FilterDescriptor, isCompositeFilterDescriptor } from '@progress/kendo-data-query';

/**
 * Removes all filters from the provided compositeFilters that match the provided field.
 * Will recursively remove filters from nested CompositeFilterDescriptors
 */
export const removeFilterByField = (filters: (CompositeFilterDescriptor | FilterDescriptor)[], field: string): (CompositeFilterDescriptor | FilterDescriptor)[] => {
  // The filter method returns a new array containing only elements for which the callback returns true
  return filters.filter((filter: CompositeFilterDescriptor | FilterDescriptor): boolean => {
    if (isCompositeFilterDescriptor(filter)) {
      filter.filters = removeFilterByField(filter.filters, field);
      // If after the recursive removal, the resulting array is empty then it will not be apart of the final filters array
      return filter.filters.length > 0;
    } else {
      // We've drilled down to a FilterDescriptor, so we can check the field property and remove it if it matches
      return filter.field !== field;
    }
  });
};

export const compositeToSelectedFilters = (openOrderFilters?: CompositeFilterDescriptor[]): { [field: string]: FilterOption[] } => {
  if (!openOrderFilters || openOrderFilters.length === 0) {
    return {};
  }

  const result: { [field: string]: FilterOption[] } = {};
  openOrderFilters.forEach((comp) => {
    comp.filters.forEach((f: any) => {
      if (!result[f.field]) result[f.field] = [];
      result[f.field].push({ name: f.value, value: f.value });
    });
  });
  return result;
};
